import React from "react";
import { BtnLoader } from "../../../../../Components/Components";
import { svg } from "../../../../../Assets/svg";
import { Field, Form, Formik } from "formik";
import { Input, Modal } from "antd";
import { changeOrderIdSchema } from "../../../../validationSchema/common";
import {
  RootState,
  useAppDispatch,
  useAppSelector,
} from "../../../../../store";
import { UpdateOrderIdAPI } from "../../../../Redux/orders";
import { useParams } from "react-router-dom";

const ChangeOrderNumber: React.FC<{
  visible: boolean;
  setIsModalVisible: React.Dispatch<React.SetStateAction<boolean>>;
  order_id: any;
}> = ({ visible, setIsModalVisible, order_id }) => {
  const { id } = useParams();
  const dispatch = useAppDispatch();
  const { updateOrderIdLoading } = useAppSelector(
    (state: RootState) => state?.loading,
  );
  const onClose = () => {
    setIsModalVisible(false);
  };
  const handleSave = (values: any) => {
    const payload: any = {
      order_id: values?.order_id?.trim(),
      id: id,
    };

    const handleSuccess = () => {
      setIsModalVisible(false);
    };
    dispatch(UpdateOrderIdAPI(payload, handleSuccess));
  };
  return (
    <Modal
      title={
         <div className="text-center fs-4 fw-bolder lh-m">
          Change Order Id?
        </div>
      }
      visible={visible}
      onCancel={onClose}
      width={"32.813rem"}
      closeIcon={svg.closeIcon}
      centered
      footer={
        <div className="d-flex justify-content-center gap-4">
          <button
            type="button"
            className="btn btn-lg btn-outline-secondary min-w-130"
            onClick={onClose}
            disabled={updateOrderIdLoading}
          >
            Cancel
          </button>
          <button
            // type="submit"
            form="submitChangeOrderId"
            disabled={updateOrderIdLoading}
            className={`btn btn-lg min-w-130 btn-primary`}
            // onClick={handleDelete}
          >
            {updateOrderIdLoading ? <BtnLoader /> : "Save"}
          </button>
        </div>
      }
      className="custom-modal"
    >
      <p className="fs-6 d-flex justify-content-center mt-3 text-center text-4a4a4a">
        You are about to change the Order ID. This will update the order’s
        identification number in the system. Do you want to continue?
      </p>
      <Formik
        initialValues={{
          order_id: order_id,
        }}
        validationSchema={changeOrderIdSchema}
        onSubmit={handleSave}
        enableReinitialize
      >
        {({
          values,
          handleChange,
          handleBlur,
          handleSubmit,
          errors,
          touched,
          setFieldValue,
        }: any) => {
          return (
            <Form id="submitChangeOrderId" onSubmit={handleSubmit}>
              <div className="row gy-3">
                <div className="col-md-12">
                  <div className="form-item">
                    <label className="custom-label mb-1 ff">Order Id</label>
                    <Field
                      name="order_id"
                      className="form-control form-control-lg"
                      value={values?.order_id}
                      // onChange={handleChange}
                      onBlur={handleBlur}
                      placeholder={"Enter Order Id"}
                      as={Input}
                      onChange={(e: any) => {
                        setFieldValue("order_id", e.target.value);
                      }}
                    />
                    {errors?.order_id && touched?.order_id && (
                      <div className="text-danger fs-8">{errors?.order_id}</div>
                    )}
                  </div>
                </div>
              </div>
            </Form>
          );
        }}
      </Formik>
    </Modal>
  );
};

export default ChangeOrderNumber;
